import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// Persist these values automatically to localStorage
export const sessionAtom = atomWithStorage('mailflow_session_id', null);
export const expiryAtom = atomWithStorage('mailflow_expiry_time', null);
export const userAtom = atomWithStorage('mailflow_user_id', null);

// Derived atom to check if user is logged in efficiently
export const isLoggedInAtom = atom((get) => {
    const session = get(sessionAtom);
    const expiry = get(expiryAtom);
    
    if (!session || !expiry) return false;
    
    const currentTime = new Date().getTime();
    return currentTime < parseInt(expiry);
});